import { gql } from '@apollo/client';

export const ADMIN_USERS_QUERY = gql`
  query AdminUsers {
    adminUsers {
      id
      email
      firstName
      lastName
      displayName
      role
      verified
      createdAt
      findCount
      siteCount
      objectCount
      hasVipAccess
      premiumAccess {
        isPremium
        sources
        expiresAt
      }
    }
  }
`;
